import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import getNameByID from "../../../../../functions/getNameByID";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import PaidIcon from "@mui/icons-material/Paid";
import { Get_limited_From_MongoDB_With_Search } from "../../../../api/Get_limited_From_MongoDB_With_Search";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";
import { Link } from "react-router-dom";
import GetServerAddress from "../../../../../functions/GetServerAddress";
import axios from "axios";

function WEF({ Attendee, setAttendee, Staff, id }) {
  const { logout } = StaffuseAuth();

  let ProgressOptions = [
    "Incomplete",
    "In_Progress",
    "Awaiting_Review",
    "Complete",
  ];

  let WEF_Props = [
    "BasicInfo",
    "GeneralInfo",
    "EmergancyMedicalInfo",
    "SENDInfo",
    "ContactInfo",
    "PermissionsInfo",
  ];

  let WEF_Answer_Props = [
    "SEFGeneralInfo",
    "SEFEmergancyMedicalInfo",
    "SEFSENDInfo",
    "SEFPermissionsInfo",
  ];

  console.log("Attendee");
  console.log(Attendee);

  const handleProgressChange = (e) => {
    setAttendee({
      ...Attendee,
      SEFProgress: { ...Attendee.SEFProgress, [e.target.name]: e.target.value },
    });
  };

  //given a object like that of Attendee_Two, go through each value in WEF_Props. If it exists, find and return an object that contains both the name of the WEF_Prop and the name of the prop. return everything as an array
  const getWEFValues = (WEF_Answer_Props, Attendee) => {
    let WEFValues = [];
    WEF_Answer_Props.forEach((WEF_Answer_Prop) => {
      if (Attendee && Attendee[WEF_Answer_Prop]) {
        Object.keys(Attendee[WEF_Answer_Prop]).forEach((prop) => {
          WEFValues.push({
            WEF_Answer_Prop: WEF_Answer_Prop,
            prop: prop,
          });
        });
      }
    });
    return WEFValues;
  };

  const WEFValues = getWEFValues(WEF_Answer_Props, Attendee);

  function handleGoToSEF(e) {
    e.preventDefault();
    console.log("yeet");
    if (Attendee?.MetaData?.Password) {
      localStorage.setItem("Student_id", Attendee?._id);
      console.log("localStorage");
      console.log(localStorage);
      window.open(
        `/Student/login/${Attendee._id}/${Attendee?.MetaData?.Password}`,
        "_blank"
      );
    } else {
      window.alert("No Password");
    }
  }
  //  <Link
  //     to={`/Staff/StudentHomePage`}
  //     style={{ textDecoration: "none", color: "inherit" }}
  //   >
  //     <button>View</button>
  //   </Link>
  //--------------------------------------------------------------------------------

  return (
    <section>
      <h2>SEF/WEF Progress </h2>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          {WEF_Props.map((WEF_Prop) => (
            <>
              <TextField
                key={WEF_Prop}
                name={WEF_Prop}
                label={WEF_Prop}
                variant="outlined"
                margin="normal"
                fullWidth
                value={Attendee?.SEFProgress?.[WEF_Prop] || ""}
                onChange={handleProgressChange}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                select
              >
                <MenuItem key={"null"} value={""}>
                  ----
                </MenuItem>
                {ProgressOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </>
          ))}
        </Grid>
      </Grid>
      <div style={{ marginTop: "20px" }}></div>
      <h2>SEF/WEF Answers </h2>

      <button onClick={(e) => handleGoToSEF(e)}>Go To WEF/SEF</button>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          {WEFValues.map((WEFValue) => (
            <>
              {[WEFValue.WEF_Answer_Prop] || ""}, {[WEFValue.prop] || ""}
              <TextField
                // key={WEFValue.WEF_Answer_Prop[WEFValue.prop]}
                // name={WEFValue.WEF_Answer_Prop[WEFValue.prop]}
                // label={WEFValue.WEF_Answer_Prop[WEFValue.prop]}
                variant="outlined"
                margin="normal"
                fullWidth
                value={
                  Attendee?.[WEFValue.WEF_Answer_Prop][WEFValue.prop] || ""
                }
                //onChange={handleProgressChange}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
              />
            </>
          ))}
        </Grid>
      </Grid>
      <div style={{ marginTop: "20px" }}></div>
    </section>
  );
}

export default WEF;
